// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#tab-container div > nav.tabs > ul > li.is-active > a {\n  margin-right: .5rem;\n  color: white;\n  background-color: var(--primary);\n  color: white;\n}\n#tab-container div > nav.tabs > ul > li > a {\n  margin: .5rem;\n  border: none;\n  border-radius: 7px;\n  background-color: hsl(0, 0%, 96%);\n  color: var(--info-dark);\n}\n#tab-container > div > section {\n  padding: .5rem;\n}\n", ""]);
// Exports
module.exports = exports;
